// extracted by mini-css-extract-plugin
export default {"text":"style_text__R7Ygr","f18":"style_f18__3sP6N","f16":"style_f16__f9XE+","f14":"style_f14__w2Q34"};